import React from 'react'
import Slider from 'react-slick'
import banner from '../../../public/assets/img/WomansCategory/banner.png'
import { useAppDispatch } from 'src/store/store'
import { guestAccountDetailSlice } from 'src/store/slices/guestAccountDetailSlice'
import { useRouter } from 'next/router'

export default function WomenBannerSection({}) {
  const dispatch = useAppDispatch()
  const router = useRouter()

  const settings = {
    dots: true,
    infinite: true,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 10000,
    pauseOnHover: true,
  }
  const WomenBannerVideo = [
    'https://bluejestic-media.storage.googleapis.com/bluejestic-stage/women/banner/cute-young-girl-with-dark-wavy-hairstyle-bright-makeup-silk-dress-black-jacket-holding-sunglasses-hands-looking-away-against-beige-building-wall 1-1702284503236-715549938.png',
  ]

  return (
    <section className="section_1">
      <div className="bannner_slider">
        {/* <Slider {...settings}> */}
        {[...Array(1)].map((data, index) => {
          return (
            <div key={index} className="bannner_slider_cover">
              <div className="img_cover">
                {/* <img src={WomenBannerVideo[index]} alt="img_cover" /> */}
                <video loop autoPlay muted>
                  <source
                    src="https://bluejestic-media.storage.googleapis.com/bluejestic-stage/store/admin/globus_women's_fashion (1080p)-1705645131385-552419583.mp4"
                    type="video/mp4"
                  />
                  {/* <source src="/assets/Video/women-video.mp4" type="video/mp4" /> */}
                </video>
              </div>
              <div className="banner_content">
                <div className="container">
                  <div className="content_cover">
                    <h1>New Collection</h1>
                    <p className="subtext">
                      We're Coming In Hot With Sequins And Satin Paired With Moody Metallic Leather
                    </p>
                    <button className="banner_btn" onClick={() => { router.push('/search/?q=leather+jacket&type=product')}}>
                      <p>Shop Now</p>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )
        })}
        {/* </Slider> */}
      </div>
    </section>
  )
}
